import React, { useState } from 'react';
import PlanningDetailSnapshotService from '../../../Services/PlanningDetailSnapshotService.js';
import PlanningDetailSnapshotItem from '../../../Domain/PlanningDetailSnapshotItem.js';
import PlanningDetailSnapshotSearchParams from './PlanningDetailSnapshotSearchParams.js';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

function PlanningDetailSnapshotHistory() {
  const [snapshots, setSnapshots] = useState([]);
  const [searchItem, setSearchItem] = useState(() => new PlanningDetailSnapshotSearchParams());

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={PlanningDetailSnapshotItem}
        serviceFunction={PlanningDetailSnapshotService.GetSnapshotListBySearching}
        convertDBItemsFunction={PlanningDetailSnapshotService.ConvertDBSnapshots}
        showSearchStrip={true}
        searchItem={searchItem}
        searchParamsType={PlanningDetailSnapshotSearchParams}
        clickOnStartSearch={(newSearchItem) => setSearchItem(newSearchItem)}
        itemList={snapshots}
        changeOfItemListFunction={(itemList) => setSnapshots(itemList)}
        orderBy='SnapshotDateUtc'
        errorCode='PDSH1'
      />
    </div>
  );
}

export default PlanningDetailSnapshotHistory;
